import { connect } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { addMediaToTier } from '../redux/creator/actions';
import { ModalType } from '../../Modals/redux/types';
const mapStateToProps = (state, ownProps)=>({});
const mapDispatchToProps = (dispatch, ownProps)=>({
        addMediaToTier: (deviations)=>{
            dispatch(addMediaToTier({
                deviations,
                tierDeviation: ownProps.tierDeviation
            }));
        },
        pushLoadingModal: ()=>{
            dispatch(pushModal(ModalType.LOADING_SCREEN, {
                wrapInModal: false
            }));
        }
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=TierManageContentButton.container.js.map